import React, { useState } from "react";
import "./Conversations.scss";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import ConversationCard from "./ConversationCard/ConversationCard";
import { HiSearch } from "react-icons/hi";
import { InputText } from "primereact/inputtext";
import { Divider } from "primereact/divider";

const Conversations = (props) => {
  const [filtreMotsCles, setFiltreMotsCles] = useState("");

  // filtre sur les noms et prénoms des interlocuteurs
  const filterByMotsCles = () => {
    if (filtreMotsCles && filtreMotsCles != "") {
      return props.messages.myConversations.filter((conversation) =>
        conversation.users.some(
          (user) =>
            user.firstname
              .toLowerCase()
              .includes(filtreMotsCles.toLowerCase()) ||
            user.surname.toLowerCase().includes(filtreMotsCles.toLowerCase())
        )
      );
    }
    return props.messages.myConversations;
  };

  return (
    <div className="conversation_container">
      <div className="conversation_container_top">
        <h1>Conversations :</h1>
        <div className="search_conversation">
          <HiSearch className="search_conversation_icon" />
          <InputText
            placeholder={`Rechercher une conversation`}
            value={filtreMotsCles}
            onChange={(e) => {
              setFiltreMotsCles(e.target.value);
            }}
            className="search_conversation_input"
          />
        </div>
      </div>

      <div className="conversation_container_bottom">
        {filterByMotsCles().length > 0 ? (
          filterByMotsCles().map((conversation, index) => (
            <>
              <ConversationCard
                key={index}
                conversationDetails={conversation}
              ></ConversationCard>
              <Divider
                layout="horizontal"
                className="conversation_container_bottom_divider"
              />
            </>
          ))
        ) : props.messages.myConversations.length > 0 ? (
          <span className="empty_message">
            Aucune conversation ne correspond à votre recherche
          </span>
        ) : (
          <span className="empty_message">
            Vous n&apos;avez échangé aucun message
          </span>
        )}
      </div>
    </div>
  );
};

Conversations.propTypes = {
  auth: PropTypes.object,
  messages: PropTypes.object,
};
const mapStateToProps = (state) => ({
  auth: state.auth,
  messages: state.messages,
  pagination: state.pagination,
});

export default connect(mapStateToProps)(Conversations);
